import React, { useEffect } from 'react';
import { BsGithub } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa';
import { FaReact, FaNodeJs } from 'react-icons/fa';
import { SiMongodb, SiFirebase, SiReactrouter, SiRedux } from 'react-icons/si';
// import { SiMui } from 'react-icons/si' //SiMui kaj kore na

import img1 from '../../../images/project-details/job-nexus/1.png';
import img2 from '../../../images/project-details/job-nexus/2.png';
import img3 from '../../../images/project-details/job-nexus/3.png';
import img4 from '../../../images/project-details/job-nexus/4.png';
import img5 from '../../../images/project-details/job-nexus/5.png';
import img6 from '../../../images/project-details/job-nexus/6.png';


import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import useTitle from '../../../Hooks/useTitle';



const JobNexusDetails = () => {

    useTitle('Project | Job Nexus')

    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])

    return (
        <div className='md:px-8 px-3'>

            <div className='flex justify-center items-center md:flex-row lg:flex-row sm:flex-col-reverse flex-col-reverse mb-12 mt-16'>
                <h1 className='uppercase text-center text-3xl sm:text-3xl md:text-4xl lg:text-4xl  animation lg:mt-0 md:mt-0 sm:mt-6 mt-6' data-aos='flip-right'>Job <span className='text-rose-600 md:text-6xl text-5xl'>Nexus</span></h1>
            </div>


            <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-x-10  gap-y-8 mb-24 animation' data-aos='zoom-in'>

                <div className="card   lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img1} alt="job!" />
                </div>

                <div className="card  lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img2} alt="job!" />
                </div>

                <div className="card  lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img3} alt="job!" />
                </div>

                <div className="card lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img4} alt="job!" />
                </div>

                <div className="card   lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img5} alt="job" />
                </div>

                <div className="card  lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img6} alt="job" />
                </div>

            </div>

            <div>
                <h1 className='uppercase my-10 text-center text-3xl sm:text-3xl md:text-5xl lg:text-5xl font-mono text-cyan-600 font-bold ' >Features & Source Code
                </h1>

                <div className="flex justify-evenly  lg:flex-row md:flex-col-reverse sm:flex-col-reverse flex-col-reverse lg:mx-0 md:mx-8 sm:mx-4 mx-3 mb-24 gap-x-10">

                    <div className="bg-gray-800 px-6 py-6 rounded-2xl shadow-2xl w-full sm:w-full md:w-full lg:w-2/4">

                        <h1 className='text-justify text-lg' > ⚪ Job Nexus is basically a platform where a job poster can post jobs based the requirements, experience, location etc. A user can see all the posted Jobs in the website but he can perform CRUD operation only to the jobs he posted. This is basically a website to perform the CRUD operation by different users based on their role </h1> <br></br>

                        <h1 className='text-justify text-lg '> ⚪ This website is made by using React Router DOM, Firebase Authentication, amd Mongodb as the database. Redux is used in this website to make the API calls and all the functionality is managed by Redux Thunk. Besides Material UI is used for the styling purpose.</h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪  React hot toast and sweet alert is added to show the alerts for better user experience. For the server side I have used node.js and express.js for the server purpose. </h1> <br></br>


                        <h1 className='text-justify text-lg'> ⚪ Authentication is an important part of the website. There are some routes that are private routes. Which means a user can not visit the route if he is not logged in. For the Authentication purpose I have used the google's Firebase authentication system. I have added some authentication systems. Email-Password Login and Google Login </h1>


                    </div>


                    <div className='w-full sm:w-full md:w-full lg:w-2/4'>

                        <h2 className='text-center text-3xl mt-4 mb-12 '>GitHub Links <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                        <div >


                            <a href='https://fir-job-portal-e7c35.web.app/' target='blank' title='Live Site Demo'>
                                <div className='relative group mt-4 animation' data-aos='fade-left'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-gradient-to-r from-pink-600 to-violet-400 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Live Website</span>
                                            <FaEye className='text-3xl text-white'></FaEye>
                                        </div>
                                    </button>
                                </div>
                            </a>


                            <a href='https://github.com/Fahimsakib1/job-nexus-client' target='blank' title='Client Side Code'>
                                <div className='relative group mt-4 animation' data-aos='fade-right'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-blue-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Client Side Code</span>
                                            <BsGithub className='text-3xl text-white'></BsGithub>
                                        </div>
                                    </button>
                                </div>
                            </a>



                            <a href='https://github.com/Fahimsakib1/job-nexus-server' target='blank' title='Server Side Code'>
                                <div className='relative group mt-4 animation' data-aos='fade-left'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-green-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Server Side Code</span>
                                            <BsGithub className='text-3xl text-white'></BsGithub>
                                        </div>
                                    </button>
                                </div>
                            </a>










                        </div>

                        <h2 className='text-center text-3xl mt-12 mb-8 '>Technologies Used <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                        <div className='flex justify-center items-center flex-wrap  gap-x-8 lg:mb-0 md:mb-8 sm:mb-12 mb-12 animation' data-aos='fade-up'>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <FaReact className='text-4xl mx-2 text-cyan-500'></FaReact>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React JS</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiRedux className='text-4xl mx-2 text-violet-700'></SiRedux>
                                <h1 className='text-white text-2xl py-2  mr-4'>Redux</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <FaNodeJs className='text-4xl mx-2 text-green-500'></FaNodeJs>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Node JS</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiFirebase className='text-4xl mx-2 text-yellow-400'></SiFirebase>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Firebase</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiReactrouter className='text-4xl mx-2 text-red-600'></SiReactrouter>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React Router</h1>
                            </div>

                            <div className='border-2 border-blue-500 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                {/* <SiMui className='text-4xl mx-2 text-blue-500'></SiMui> */}
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4 px-3'>Material UI</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiMongodb className='text-4xl mx-2 text-green-500'></SiMongodb>
                                <h1 className='text-white text-2xl py-2  mr-4'>MongoDB</h1>
                            </div>

                        </div>


                    </div>

                </div>





                {/* <div className='mx-auto text-center '>
                    <Link to='/'>
                        <button className='btn btn-primary w-[300px] sm:w-[300px] md:w-[400px] bg-black text-white text-xl border-2  hover:border-teal-500 border-violet-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 border-b-4 border-t-0 border-r-2 border-l-0 hover:bg-black hover:text-white'>Back To Home Page</button>
                    </Link>
                </div> */}



                <div className='mx-auto text-center my-10 '>
                    <Link to='/'>
                        <button className='cursor-pointer hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150 px-6 py-2 rounded-sm  text-white text-lg mt-3 border-0 bg-blue-800' title='Download Resume'>
                            Back To Home Page
                        </button>
                    </Link>
                </div>




            </div>
        </div>
    );
};

export default JobNexusDetails;